const de = {
  nav: {
    home: 'Start',
    about: 'Über mich',
    resume: 'Lebenslauf',
    principle: 'Arbeitsweise',
    contact: 'Kontakt',
  },
  hero: {
    firstName: 'Murat',
    lastName: 'Selcukoglu',
    greeting: 'Hallo, ich bin',
    occupation: 'Mobile Frontend Entwickler',
    from: 'aus',
    description:
      'Lass uns einen Blick auf das werfen, was ich tue – willkommen in meiner Welt.',
    cta: 'Mehr über mich',
    download: 'Lebenslauf herunterladen',
    scroll: 'Nach unten scrollen',
  },
  about: {
    title: 'Über mich',
    bio: 'Mein Name ist Murat. Ich bin Mobile Frontend Entwickler mit über vier Jahren Erfahrung in der Entwicklung mobiler und webbasierter Anwendungen mit React Native und React (Next.js). Mein Schwerpunkt liegt auf skalierbaren, hochperformanten Benutzeroberflächen, der Integration von RESTful-APIs sowie der Umsetzung kompletter Release-Zyklen für den App Store und Google Play – inklusive Deployment, Updates und Performance-Optimierung. Ich schreibe sauberen, gut lesbaren Code und gestalte Oberflächen, die ästhetisches Design mit Barrierefreiheit für alle Nutzer verbinden.',
    contactDetails: 'Kontaktdaten',
    downloadResume: 'Lebenslauf herunterladen',
    location: 'Standort',
    email: 'E-Mail',
    phone: 'Telefon',
  },
  resume: {
    educationTitle: 'Ausbildung',
    workTitle: 'Berufserfahrung',
    skillsTitle: 'Fähigkeiten',
    skillMessage:
      'React Native und React.js sind mein bevorzugter Frontend-Stack, ergänzt durch fundierte JavaScript-Kenntnisse. Ich habe zahlreiche iOS- und Android-Apps erfolgreich veröffentlicht und beherrsche den gesamten Entwicklungszyklus von der ersten Idee bis zum produktiven Release.',
    present: 'Heute',
    education: [
      {
        school: 'Nationale Verteidigungsuniversität — Ankara, Türkei',
        degree: 'B.Sc. Systemingenieurwesen',
        graduated: '2009 – 2013',
        description:
          'Bachelor of Science in Systemingenieurwesen mit den Schwerpunkten System Engineering, Softwareentwicklung, IT-Systeme und Systemarchitekturen. Von der ZAB (Zentralstelle für ausländisches Bildungswesen) als deutscher Hochschulabschluss auf Bachelor-Ebene anerkannt.',
      },
    ],
    work: [
      {
        slug: 'akinon',
        company: 'Akinon',
        title: 'Mobile Frontend Entwickler',
        years: 'Juni 2023 – August 2025',
        description:
          'Als React Native Entwickler war ich auf E-Commerce-Anwendungen für namhafte Einzelhandelsmarken spezialisiert. Ich leitete die Entwicklung und Einführung der Lacoste-App in der Türkei, die weltweit als erste ihrer Art umgesetzt wurde, und war an der Entwicklung der in der arabischen Region sehr beliebten Lulu-Supermarket-App beteiligt. Außerdem spielte ich eine aktive Rolle bei der Implementierung von Anwendungen für Marken wie Marks & Spencer, GAP, Koton, Intersport und Forever21 und war an der Wartung zahlreicher weiterer Marken innerhalb des Unternehmens beteiligt. Diese Projekte haben meine Fähigkeiten in der Entwicklung benutzerfreundlicher Oberflächen, der Sicherstellung robuster Performance und der effektiven Zusammenarbeit in funktionsübergreifenden Teams weiter ausgebaut.',
      },
      {
        slug: 'cyberkoc',
        company: 'CyberKOC (Freelance)',
        title: 'Mobile Frontend Entwickler',
        years: 'März 2024 – August 2025',
        description:
          'Ich entwickelte „Al Moheet“, eine mobile Buch-Lese-App für ein Verlagshaus, unter Verwendung von React Native. Ich war verantwortlich für die Veröffentlichungsprozesse im App Store und bei Google Play, einschließlich Deployment, Updates und Wartung. Meine Aufgaben umfassten die Optimierung der App-Performance, die Implementierung neuer Funktionen sowie die Sicherstellung eines reibungslosen und konsistenten Nutzererlebnisses auf allen Plattformen.',
      },
      {
        slug: 'yapisepeti',
        company: 'Yapı Sepeti (Freelance)',
        title: 'React Native Entwickler',
        years: 'März 2023 – Juli 2023',
        description:
          'Mitarbeit an der Entwicklung der mobilen Anwendung von Yapı Sepeti mit React Native. Verantwortlich für die Umsetzung von Benutzeroberflächen, die Integration von APIs sowie die Entwicklung neuer Funktionen und die Optimierung bestehender Features. Durchführung von Fehleranalysen und Behebung technischer Probleme zur Verbesserung der Stabilität und Performance der Anwendung.',
      },
      {
        slug: 'mobrespos',
        company: 'Mobrespos Software',
        title: 'Mobile Frontend Entwickler',
        years: 'April 2021 – Juni 2023',
        description:
          'Ich arbeitete über zwei Jahre an der Entwicklung und Weiterentwicklung mobiler Anwendungen mit React Native und begleitete den gesamten Entwicklungszyklus von der Konzeption über die Implementierung und das Testing bis hin zur Veröffentlichung und Wartung. Dabei entwickelte ich benutzerfreundliche Mobile Apps für Restaurant- und digitale Bestellsysteme und setzte moderne UI/UX-Konzepte für eine optimale Nutzererfahrung um. Zusätzlich entwickelte und wartete ich Webanwendungen mit React, integrierte Backend-Dienste über RESTful APIs und arbeitete an neuen Funktionen, Prozessverbesserungen sowie der Performance und Stabilität der Anwendungen auf unterschiedlichen Plattformen.',
      },
      {
        slug: 'msb',
        company: 'MSB (Verteidigungsministerium)',
        title: 'Systemingenieur',
        years: 'August 2013 – April 2021',
        description:
          'Als Systemingenieur war ich über mehrere Jahre für die Analyse, Planung, Implementierung und Weiterentwicklung technischer Systeme verantwortlich. Ich sammelte umfangreiche Erfahrungen in der Verwaltung komplexer IT- und Kommunikationsinfrastrukturen – darunter die Installation, Konfiguration und Wartung von Hard- und Softwaresystemen, die Durchführung von Systemanalysen sowie die Identifikation und Behebung technischer Probleme. Darüber hinaus arbeitete ich an der Optimierung bestehender Systemarchitekturen, der Verbesserung der Systemstabilität, der Planung und Umsetzung technischer Projekte sowie der Erstellung technischer Dokumentationen in Zusammenarbeit mit verschiedenen Fachbereichen.',
      },
    ],
  },
  testimonials: {
    title: 'Meine Arbeitsweise',
    subtitle: 'Was mich antreibt',
    items: [
      {
        text: 'Ich bin ein erfahrener Softwareentwickler mit umfassender Expertise im Entwurf und in der Entwicklung robuster Software-Lösungen. Mein Profil zeichnet sich durch ausgeprägte Problemlösungsfähigkeiten und einen gründlichen Testansatz aus. In meiner Karriere habe ich kontinuierlich hochwertige Software geliefert – durch die Kombination aus technischem Know-how und höchster Sorgfalt im Detail. Ich entfalte mich in dynamischen Umgebungen und löse komplexe Herausforderungen effizient und präzise.',
        user: 'Murat SELCUKOGLU',
        role: 'Entwicklerphilosophie',
      },
      {
        text: 'Ich glaube an wartbaren Code: einfach, gut lesbar und auf das Wesentliche reduziert. Eine schnelle Auslieferung ist wichtig – aber langfristig zählt der Code, den das Team in sechs Monaten noch versteht. Deshalb investiere ich Zeit in Architektur, Code-Reviews und automatisierte Tests.',
        user: 'Murat SELCUKOGLU',
        role: 'Code-Qualität',
      },
      {
        text: 'Performance ist kein Bonus – sie ist Teil der Nutzererfahrung. Vom Bundle-Size-Tuning über Render-Optimierungen bis zu nativen Modulen: Ich messe, analysiere und optimiere kontinuierlich, damit die App nicht nur funktioniert, sondern sich auch flüssig anfühlt.',
        user: 'Murat SELCUKOGLU',
        role: 'Performance & UX',
      },
    ],
  },
  contact: {
    title: 'Schreib mir',
    lead: 'Hast du ein Projekt im Kopf oder möchtest einfach Hallo sagen? Ich freue mich auf deine Nachricht und melde mich so schnell wie möglich.',
    name: 'Name',
    email: 'E-Mail',
    subject: 'Betreff',
    message: 'Nachricht',
    submit: 'Nachricht senden',
    sending: 'Wird gesendet…',
    success: 'Deine Nachricht wurde erfolgreich gesendet. Vielen Dank!',
    error: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
    required: 'Pflichtfeld',
    sidebarTitle: 'Adresse & Telefon',
    available: 'Verfügbar für neue Projekte',
  },
  footer: {
    rights: 'Alle Rechte vorbehalten.',
    builtWith: 'Mit React & Liebe entwickelt von',
    backToTop: 'Nach oben',
  },
};

export default de;
